import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getVacationDaysAccrualTypeTranslationKey(
	type: Enums<"vacationDaysAccrualType">,
): TranslationKey {
	switch (type) {
		case "monthly":
			return "absences.accrual_type.monthly";
		case "upfront":
			return "absences.accrual_type.upfront";
	}
}
